module.exports = __webpack_public_path__ + "img/logo.35ac7e25.jpg";